import { render, staticRenderFns } from "./DocumentByCategoryAndYear.vue?vue&type=template&id=dbc6d028&scoped=true&"
import script from "./DocumentByCategoryAndYear.vue?vue&type=script&lang=js&"
export * from "./DocumentByCategoryAndYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc6d028",
  null
  
)

export default component.exports